import { useEffect, useState } from "react";

const SPY_ROOT_MARGIN = "-30% 0px -60% 0px";

interface Props {
	sectionIds: readonly string[];
}

export function useFeatureSpy({ sectionIds }: Props): string | null {
	const [activeId, setActiveId] = useState<string | null>(null);

	useEffect(() => {
		if (typeof IntersectionObserver === "undefined") {
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				for (const entry of entries) {
					if (entry.isIntersecting) {
						setActiveId(entry.target.id);
					}
				}
			},
			{ rootMargin: SPY_ROOT_MARGIN },
		);

		for (const id of sectionIds) {
			const element = document.getElementById(id);
			if (element) {
				observer.observe(element);
			}
		}

		return () => {
			observer.disconnect();
		};
	}, [sectionIds]);

	return activeId;
}
